import React from "react";
import Page from "components/Page";
import { Props } from "./ProjectCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ProjectCustomTypes = lazyWithRetry(() => import("./ProjectCustomTypes"));

export default (props: Props) => (
  <Page>
    <ProjectCustomTypes {...props} />
  </Page>
);
